<template>
  <div>

    <el-form :rules="FormHata" :model="Urun"
             @submit.prevent.native="HareketEkle"
             ref="RaporForm">
      <el-form-item label="Seri Numaraları" prop="Seri">
        <el-select
          v-model="Urun.Seri"
          multiple
          filterable
          :allow-create="Urun.Tur=='Giris'"
          default-first-option
          placeholder="Seri Numarası okutunuz">
          <el-option
            v-if="Urun.Tur==='Cikis'"
            v-for="item in Stoks"
            :key="item.Seri"
            :label="item.Seri"
            :value="item.Seri">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Hareket Açıklaması" prop="Aciklama">
        <el-input v-model="Urun.Aciklama" type="textarea"></el-input>
      </el-form-item>
      <el-form-item>
        <el-switch
          @change="Urun.Seri=null"
          style="display: block"
          v-model="Urun.Tur"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Giriş Hareketi"
          inactive-text="Çıkış Hareketi"
          active-value="Giris"
          inactive-value="Cikis"
        >
        </el-switch>
      </el-form-item>
      <el-button type="primary" class="btn-block" @click="HareketEkle">Kaydet</el-button>
    </el-form>
  </div>

</template>

<script>
export default {
  props: ['Urun_id'],
  data() {
    return {
      Stoks: null,
      Urun: {
        Seri: null,
        Aciklama: '',
        Tur: 'Giris'
      },
      FormHata: {
        Seri: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    HareketEkle() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {
            ...this.Urun, path: '_enerji/stok/hareket/' + this.Urun_id
          })
            .then(response => {
              this.Urun = {
                Seri: null,
                Aciklama: '',
                Tur: 'Giris'
              }
              this.SayfaYukle();
              this.$emit("SayfaYenile")
            })
        }
      })
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {
        path: '_enerji/stok/hareket/' + this.Urun_id
      })
        .then(response => {
          this.Stoks = response.Stok
        })
    }
  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Stok/Comp/Hareket.vue